import { v4 as uuidv4 } from 'uuid';
import { DisclosureContent } from '../../../../vtex-apps/disclosure-layout/DisclosureContent/default';
import { DisclosureLayout } from '../../../../vtex-apps/disclosure-layout/DisclosureLayout/default';
import { DisclosureLayoutGroup } from '../../../../vtex-apps/disclosure-layout/DisclosureLayoutGroup/default';
import { DisclosureStateIndicator } from '../../../../vtex-apps/disclosure-layout/DisclosureStateIndicator/default';
import { DisclosureTrigger } from '../../../../vtex-apps/disclosure-layout/DisclosureTrigger/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { ProductSpecificationGroup } from '../../../../vtex-apps/product-specification/ProductSpecificationGroup/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { ProductDescription } from '../../../../vtex-apps/store-components/ProductDescription/default';
import { ProductSpecification } from '../../../../vtex-apps/product-specification/ProductSpecification/default';
import { ProductSpecificationText } from '../../../../vtex-apps/product-specification/ProductSpecificationText/default';
import { ConditionLayoutProduct } from '../../../../vtex-apps/ConditionLayoutProduct/default';
import { ProductSpecificationValues } from '../../../../vtex-apps/product-specification/ProductSpecificationValues/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';
// import { IconCaret } from '../../../../vtex-apps/icons/default'
export default function ProductDescriptionComponent() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'ProductSpecificationSection',
		variables,
		props: VisibilityLayout({ mzTitle: 'MZ | Especificações do produto (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow({ blockClass: 'flex-row__prod-spec-sect-1-wrapper', mzTitle: 'MZ | Especificações do produto' }, [
				FlexLayoutCol({ blockClass: 'flex-col__prod-spec-sect-1' }, [
					DisclosureLayoutGroup({}, [
						DisclosureLayout({ animated: true }, [
							DisclosureTrigger(
								{
									blockClass: 'disclosure-trigger_prod-spec-sect-1',
									as: 'h3',
								},
								[
									RichText({
										blockClass: 'rich-text__prod-spec-sect-1',
										text: 'Descrição',
										textAlignment: 'left',
									}),
									DisclosureStateIndicator({
										// Show: IconCaret({ orientation: "up",handle:"caretIcon--disclosure-trigger_prod-spec-sect-1 caretIcon vtex-store-icons-0-x-caretIcon vtex-store-icons-0-x-caretIcon--disclosure-trigger_prod-spec-sect-1" }),
										// Hide: IconCaret({ orientation: "down",handle:"caretIcon--disclosure-trigger_prod-spec-sect-1 caretIcon vtex-store-icons-0-x-caretIcon vtex-store-icons-0-x-caretIcon--disclosure-trigger_prod-spec-sect-1" }),
									}),
								],
							),
							DisclosureContent({ blockClass: 'disclosure-content_prod-spec-sect-1' }, [
								ProductDescription({
									blockClass: 'description_prod-spec-sect-1',
									collapseContent: false,
									showTitle: false,
								}),
							]),
						]),
						ProductSpecificationGroup({}, [
							ProductSpecification(
								{},
								Array(1)
									.fill(0)
									.map(() =>
										ConditionLayoutProduct({
											conditions: [
												{
													subject: 'specificationProperties',
													arguments: {
														name: 'Quantidade',
													},
												},
											],
											Then: DisclosureLayout({ animated: true }, [
												DisclosureTrigger({ blockClass: 'disclosure-trigger_prod-spec-sect-1', as: 'h3' }, [
													FlexLayoutRow(
														{
															blockClass: 'row__disclosure__prod-spec-sect-1',
															preserveLayoutOnMobile: true,
														},
														[
															FlexLayoutCol(
																{
																	blockClass: ['col__disclosure__prod-spec-sect-1'],
																	width: {
																		desktop: '100%',
																		tablet: '100%',
																		phone: '100%',
																	},
																},
																[
																	ProductSpecificationText({
																		blockClass: 'spec-name__prod-spec-sect-1',
																		message: '{specificationName}',
																	}),
																],
															),
														],
													),
													DisclosureStateIndicator({
														// Show: IconCaret({ orientation: "up",handle:"caretIcon--disclosure-trigger_prod-spec-sect-1 caretIcon vtex-store-icons-0-x-caretIcon vtex-store-icons-0-x-caretIcon--disclosure-trigger_prod-spec-sect-1" }),
														// Hide: IconCaret({ orientation: "down",handle:"caretIcon--disclosure-trigger_prod-spec-sect-1 caretIcon vtex-store-icons-0-x-caretIcon vtex-store-icons-0-x-caretIcon--disclosure-trigger_prod-spec-sect-1" })
													}),
												]),
												DisclosureContent({ blockClass: 'disclosure-content_prod-spec-sect-1-value' }, [
													FlexLayoutRow(
														{
															blockClass: 'row__disclosure__prod-spec-sect-1-value',
															preserveLayoutOnMobile: true,
														},
														[
															FlexLayoutCol(
																{
																	blockClass: 'col__disclosure__prod-spec-sect-1',
																	width: {
																		desktop: '25%',
																		tablet: '100%',
																		phone: '100%',
																	},
																},
																[
																	ProductSpecificationValues({}, [
																		ProductSpecificationText({
																			blockClass: 'spec-value__prod-spec-sect-1',
																			message: '{specificationValue}',
																		}),
																	]),
																],
															),
														],
													),
												]),
											]),
											Else: null,
										}),
									),
							),
						]),
					]),
				]),
			]),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--neutral-color-high-light', to: '--pss-1-bg-color', name: 'Background' },
			{ from: '--transparent', to: '--pss-1-trigger-bg-color', name: 'Name Background' },
			{ from: '--transparent', to: '--pss-1-box-bg-color', name: 'Value Background' },
			{
				from: '--brand-color-primary-light',
				to: '--pss-1-specification-link-color',
				name: 'Specification Link Color',
			},
			{ from: '--neutral-color-high-medium', to: '--pss-1-trigger-border-color', name: 'Border' },
			{ from: '--text-color-1', to: '--pss-1-specification-name-text-color', name: 'Spec Name Text' },
			{ from: '--text-color-1', to: '--pss-1-specification-value-text-color', name: 'Spec Value Text' },
			{ from: '--white', to: '--pss-1-specification-odd-color', name: 'Spec Bg Odd' },
			{ from: '--neutral-color-low-medium', to: '--pss-1-specification-even-color', name: 'Spec Bg Even' },
			{ from: '--text-color-1', to: '--pss-1-description-text-color', name: 'Description Text Color' },
		],
	},
	{
		type: 'borderWidth',
		list: [
			{ from: '--border-width-hairline', to: '--pss-1-trigger-bw', name: 'Trigger' },
			{ from: '--border-width-hairline', to: '--pss-1-line-bw', name: 'Line' },
		],
	},
	{ type: 'borderRadius', list: [{ from: '--border-radius-none', to: '--pss-1-box-br', name: 'Content Box' }] },
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-md', to: '--pss-1-trigger-fs', name: 'Specification Name' },
			{ from: '--font-size-sm', to: '--pss-1-description-fs', name: 'Specification Value' },
			{ from: '--font-size-lg', to: '--pss-1-specification-icon-fs', name: 'Specification Icon' },
			{ from: '--font-size-sm', to: '--pss-1-specification-name-fs', name: 'Specification Name' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--pss-1-description-fw', name: 'Specification Value' },
			{ from: '--font-weight-700', to: '--pss-1-specification-name-fw', name: 'Specification Name' },
			{ from: '--font-weight-300', to: '--pss-1-specification-icon-fw', name: 'Specification Icon' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--pss-1-description-ff', name: 'Specification Value' },
			{ from: '--main-font', to: '--pss-1-specification-name-ff', name: 'Specification Name' },
			{ from: '--main-font', to: '--pss-1-specification-icon-ff', name: 'Specification Icon' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-xxxs', to: '--pss-1-trigger-size', name: 'Specification Line-height' },
			{ from: 0, to: '--pss-1-line-size', name: 'Specification Name' },
			{ from: 0, to: '--pss-1-value-size', name: 'Specification value' },
			{ from: 0, to: '--pss-1-side-spacing', name: 'Side spacing' },
		],
	},
];
